export default "__VITE_ASSET__ukGiUC16__"